/*
 * dotSeperation seperates the value of an input with dots, and takes backspaces into account.
 */

const dotSeperation = () => {
  const element = $('.js-dot-seperate');

  if (element.length === 0) {
    return;
  }

  function isCtrlA(event) {
    let lastKey;

    if (event.ctrlKey) {
      if (event.keyCode === 65 || event.keyCode === 97) { // 'A' or 'a'
        event.preventDefault();
        return true;
      }
    }

    if (
      (lastKey && event.keyCode === 65) ||
      (lastKey && event.keyCode === 97) ||
      (lastKey && event.keyCode === 17)
    ) {
      event.preventDefault();
      lastKey = false;
      return true;
    }

    lastKey = false;
    return false;
  }

  element.on('change, keyup', (event) => {
    if (isCtrlA(event)) {
      event.preventDefault();
    } else {
      let initials = element.val();

      if (event.keyCode !== 8 && event.keyCode !== 46 && !(event.keyCode > 36 && event.keyCode < 41)) {
        /* detect backspace or del or arrow keys */
        if (element.val() !== '') {
          initials = `${initials.replace(/\./g, '').match(/[\d\D]/g).join('.').toUpperCase()}.`;
          element.val(initials.substr(0, 10));
        }
      } else if (event.keyCode === 8 || event.keyCode === 46) {
        /* on delete: check if the first character is not a dot */
        if (initials.match(/^\./) !== null) {
          initials = initials.substr(1, 10);
        }

        /* on delete: check that there are not two letters or two dots next to each other */
        if (initials.match(/[a-zA-Z]{2}/) !== null || initials.match(/[\.]{2}/) !== null) { // eslint-disable-line no-useless-escape
          initials = `${initials.replace(/\./g, '').match(/[\d\D]/g).join('.').toUpperCase()}.`;
        }

        element.val(initials.substr(0, 10));
      }
    }
  });

  element.on('blur', () => {
    /* check if last letter has a dot after it (OCTNPL-7046)... */
    if (element.val().length % 2 !== 0) {
      element.val(`${element.val()}.`);
    }
    element.valid();
  });
};

export default dotSeperation;
